
import { Axios } from "./Axios";
export const checkZoneisExist = async(lat, long) => {
    return await Axios.get(`/v1/config/get-zone-id?lat=${lat}&lng=${long}`)
}